
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('visio2Main.vrun.component', () => import('./components/Visio2Main.vue'))



